import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { updateReceiptDisplayMode } from '~/actions';
import { Button, Column, InputSelect, Label, Pressable, Row, Text } from '~/commonComponents';
import { AnimatedBoxShowHide, Box } from '~/commonComponents/Box';
import { paymentHistoryFilterOptionsLabels } from '~/constants';
import { HideRequestReportButton } from '~/constants/ff.posthog';
import { getShouldEnforcePermanentJobV2 } from '~/growthbook';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import ReceiptsAllIcon from '~/images/receipts-all-icon.svg';
import ReceiptsShiftIcon from '~/images/receipts-shift-icon.svg';
import { Colors } from '~/themes/colors';
import { DownloadReportButton } from './DownloadReportButton';

interface IProps {
  displayMode: string;
  filter: string;
  onFilterChange: (val: string) => void;
  onShowRequestReportPopup: () => void;
}

export const Toolbar = ({
  displayMode,
  filter,
  onFilterChange,
  onShowRequestReportPopup,
}: IProps) => {
  const dispatch = useDispatch();

  const isHideRequestReportButton = useFeatureFlag(HideRequestReportButton);
  const isEnforcePermanentJobV2 = useRef(getShouldEnforcePermanentJobV2()).current;

  return (
    <Row
      width="100%"
      marginBottom={24}
      marginTop={8}
      alignItems="center"
      data-cy="payment-history-filters"
    >
      <AnimatedBoxShowHide isShow={displayMode === 'all'}>
        <Row gap={8} alignItems="center">
          <Label text="Transaction Date:" required={false} marginBottom={0} />
          <Box width={212}>
            <InputSelect
              dataCy="payment-history-filter-dropdown"
              value={filter}
              setValue={onFilterChange}
              isSelectVisible={false}
              options={Object.entries(paymentHistoryFilterOptionsLabels).map(([key, name]) => ({
                value: key,
                title: name,
              }))}
            />
          </Box>
        </Row>
      </AnimatedBoxShowHide>
      <Row marginLeft="auto" alignItems="center" gap={20}>
        {!isHideRequestReportButton && (
          <AnimatedBoxShowHide isShow={displayMode === 'all'} style={{ width: 175 }}>
            <Box height={32} display="block" />
            <Button
              dataCy="btn-request-report"
              text="Request Report"
              textStyle={{
                fontSize: 14,
                fontWeight: 700,
              }}
              style={{
                alignItems: 'center',
                backgroundColor: Colors.secondary_500,
                borderRadius: 25,
                cursor: 'pointer',
                display: 'flex',
                height: 30,
                justifyContent: 'center',
                marginTop: 0,
                padding: '8px 12px',
                width: 'auto',
              }}
              onClick={onShowRequestReportPopup}
            />
            <Box height={32} display="block" />
          </AnimatedBoxShowHide>
        )}

        <AnimatedBoxShowHide isShow={displayMode === 'all'}>
          <DownloadReportButton />
        </AnimatedBoxShowHide>

        <Column alignItems="center" height={100}>
          <Box height={32} display="block" />
          <Row>
            <Pressable onPress={() => dispatch(updateReceiptDisplayMode('shift'))}>
              <Box
                className={`button_group_container_first_option ${
                  displayMode === 'shift' ? 'selected_button_group_option' : ''
                }`}
              >
                <img src={ReceiptsShiftIcon} alt="receipts_shift_icon" />
              </Box>
            </Pressable>
            <div
              onClick={() => dispatch(updateReceiptDisplayMode('all'))}
              className={`button_group_container_last_option ${
                displayMode === 'all' ? 'selected_button_group_option' : ''
              }`}
            >
              <img src={ReceiptsAllIcon} alt="receipts_all_icon" />
            </div>
          </Row>
          <Row marginTop={5} columnGap={20}>
            <Text margin={0}>{isEnforcePermanentJobV2 ? 'Posting' : 'Shift'}</Text>
            <Text margin={0}>All</Text>
          </Row>
        </Column>
      </Row>
    </Row>
  );
};
